import React from 'react';

import { UploadTypes } from './UploadTypes';
import { DataUpload } from './DataUpload';
import { Wrapper, Content } from './ImportData.styles';
import { UPLOAD_TYPES } from './utils';

export class ImportData extends React.Component {
	state = {
		type: null,
	};

	changeUploadType = type => {
		this.setState({ type });
	};

	render() {
		const { type } = this.state;
		const { fetchBudget } = this.props;

		return (
			<Wrapper>
				<Content>
					{!type ? (
						<UploadTypes onChange={this.changeUploadType} />
					) : (
						<DataUpload
							isAppend={type === UPLOAD_TYPES.APPEND}
							fetchBudget={fetchBudget}
						/>
					)}
				</Content>
			</Wrapper>
		);
	}
}
